import script from "./TutorialsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialsPage.vue?vue&type=script&setup=true&lang=js"

import "./TutorialsPage.vue?vue&type=style&index=0&id=26f86b71&lang=css"

const __exports__ = script;

export default __exports__